/**
 * The single "Coming up" row for dayworks that have waited past the slow sign-off
 * threshold. The tallies come from the same server rule as the Projects column,
 * so the two surfaces count the same sheets.
 */

import type { UnsignedDayworkTally } from '../../contract-administration/dayworkSignOff';
import type { ActionItem } from './actionQueueItems';

export function slowDayworkRow(
  tallies: Readonly<Record<string, UnsignedDayworkTally>>,
  projects: readonly { id: string; name: string }[],
): ActionItem | null {
  // A tally for a project Home does not list (archived, or beyond the caller's list) has no tab to open.
  const slow = projects
    .map((project) => ({ project, count: tallies[project.id]?.slow ?? 0 }))
    .filter((entry) => entry.count > 0)
    .sort((a, b) => b.count - a.count || a.project.name.localeCompare(b.project.name));
  if (slow.length === 0) return null;

  const total = slow.reduce((sum, entry) => sum + entry.count, 0);
  const [first] = slow;
  return {
    id: 'dayworks-slow-sign-off',
    title: `${total} daywork${total === 1 ? '' : 's'} waiting over a week for sign-off`,
    context: slow.length === 1 ? first.project.name : `${first.project.name} and ${slow.length - 1} more project${slow.length === 2 ? '' : 's'}`,
    due: null,
    overdue: true,
    target: { view: 'project-detail', projectId: first.project.id, projectName: first.project.name, projectTab: 'dayworks' },
  };
}
